exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-responsive{display:block;width:50%;margin:0 auto}@media (min-width:960px){.btn-responsive{width:50%}}@media (min-width:768px) and (max-width:959px){.btn-responsive{width:70%}}@media (max-width:767px){.btn-responsive{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58f97aec","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/Users/LoginOrSignup/SubmitButton.vue
// module id = 873
// module chunks = 1 2